import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React, { useState } from "react"
import { Button, Col, Form, Modal } from "react-bootstrap"
import { injectIntl } from "react-intl"
import { isError } from "react-query"
import ActionButton from "../../common/button/actionbutton.component.jsx"
import { ProductExportModalProps } from "../../common/types/productItemList"
import CustomerSelect from "../../customer/selection.component"
import { InventoryLocationSelectComponent } from "../../inventory/components"
import { Service } from "../../state/inventory/exports/service"
import { EXPORT_TYPE } from "../../state/product/Types"
import { CONTACT_TYPE } from "../../utils/contacts/"
import { PRODUCT_EXPORT_MESSAGES } from "../../utils/product"
import "./productExportModal.scss"

export const ProductExportModal = injectIntl((props: ProductExportModalProps) => {
    const [selectedLocationId, setSelectedLocationId] = useState("")
    const [selectedSupplierId, setSelectedSupplierId] = useState("")
    const [exportResource, setExportResource] = useState("")
    const onClick= (e) => {
        if (exportResource == EXPORT_TYPE.PRODUCT){
            props.productExport(e)
        }
        else{
            const payload = {
                inventoryLocationId: selectedLocationId,
                supplierId: selectedSupplierId,
                search: props.filters,
                type: exportResource,
            }
            const res = Service.post(payload)
            if (isError(res) ) {
                throw new Error(res.message)
            } 
            props.onExportStartedCallback() 
        }
    }

    const handleRadioChange = (event) => {
        setExportResource(event.target.value) 
    }

    const onSupplierChange = (value: string) => {
        setSelectedSupplierId(value)
    }

    const getExportResource = (): React.ReactElement => {
        let body = <></>
        switch(exportResource) {
        case EXPORT_TYPE.INVENTORY_LEVELS:
            body = <InventoryLocationSelectComponent
                className="select-component"
                selectedValue={selectedLocationId}
                onChangeCallback={selected => setSelectedLocationId(selected.value)}
            />
            break
        case EXPORT_TYPE.SUPPLIER_COSTS:
            body = <CustomerSelect
                className="select-component"
                value={selectedSupplierId}
                contactType={CONTACT_TYPE.SUPPLIER}
                allowCreate={false}
                onChange={onSupplierChange}
                placeholder={PRODUCT_EXPORT_MESSAGES.selectAllSuppliersPlaceholder}
            />
            break
        }
        return (<div className="d-flex justify-content-between align-items-center select-container flex-wrap">
            {body}
        </div>)
    }

    return (
        <Modal
            className="custom-modal product-export"
            show={true}
            onHide={props.onCloseCallback}
            scrollable={true}
            backdrop="static"
            centered={true}
        >
            <Modal.Header closeButton>
                {props.intl.formatMessage(PRODUCT_EXPORT_MESSAGES["header"])}
            </Modal.Header>
            <Modal.Body>
                <div className="p-3">
                    <div>
                        <Form>
                            <Form.Group controlId="exportResource">
                                <Form.Label>                       
                                    {props.intl.formatMessage(PRODUCT_EXPORT_MESSAGES["select_resource"])}
                                </Form.Label>
                                <Col>
                                    <Form.Check
                                        type="radio"
                                        label="Product Details"
                                        name="exportResource"
                                        id="radioProduct"
                                        value="product"
                                        checked={exportResource === EXPORT_TYPE.PRODUCT}
                                        onChange={handleRadioChange}
                                    />
                                    <Form.Check
                                        type="radio"
                                        label="Inventory Levels"
                                        name="exportResource"
                                        id="radioInventory"
                                        value="inventory-levels"
                                        checked={exportResource === EXPORT_TYPE.INVENTORY_LEVELS}
                                        onChange={handleRadioChange}
                                    />
                                    {exportResource === EXPORT_TYPE.INVENTORY_LEVELS && getExportResource()}
                                    <Form.Check
                                        type="radio"
                                        label="Supplier Costs"
                                        name="exportResource"
                                        id="radioSupplierCosts"
                                        value="supplier-costs"
                                        checked={exportResource === EXPORT_TYPE.SUPPLIER_COSTS}
                                        onChange={handleRadioChange}
                                    />
                                    {exportResource === EXPORT_TYPE.SUPPLIER_COSTS && getExportResource()}
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <p className="p-2 text-left text-custom-light-gray">
                        {props.intl.formatMessage(PRODUCT_EXPORT_MESSAGES["export_message"],{
                            email: AppContext.getUserLoggedIn().attributes.email
                        })}
                    </p>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={props.onCloseCallback}>
                    {props.intl.formatMessage(PRODUCT_EXPORT_MESSAGES["back_button"])}
                </Button>
                <ActionButton
                    disabled={exportResource == EXPORT_TYPE.INVENTORY_LEVELS && selectedLocationId == ""}
                    className="btn btn-primary"
                    onClick={onClick}
                >
                    {props.intl.formatMessage(PRODUCT_EXPORT_MESSAGES["confirm_button"])}
                </ActionButton>
            </Modal.Footer>
        </Modal>
    )
})



// WEBPACK FOOTER //
// ./src/product/components/ProductExportModal.tsx